module.exports = __webpack_public_path__ + "static/media/icon-silverware.b2f215b3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/scenes/Wizard/parts/images/icon-silverware.svg
// module id = 987
// module chunks = 0